module.exports = __webpack_public_path__ + "b1141aade4f9795080d9790b5d9d88f8.jpg";